import { fetchSession, fetchIntercomData } from '@/lib/api';
import { snakify } from '@/lib/utils/case';
import { identify } from './segment';

export function init(identify, fetchSession, fetchIntercomData, snakify) {
  return async function init() {
    const session = await fetchSession();
    if (!session) return;
    const {
      id, intercomUserHash, firstName, lastName, ...sessionData
    } = session;
    const intercomData = await fetchIntercomData();
    const data = {
      name: `${firstName} ${lastName}`,
      ...sessionData,
      ...intercomData,
    };
    identify(id, snakify(data), { Intercom: { user_hash: intercomUserHash } });
  };
}

export default init(identify, fetchSession, fetchIntercomData, snakify);
